var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading-spinner-wrapper"},[_c('b-overlay',{attrs:{"show":true,"variant":"transparent","spinner-variant":"secondary","blur":"1px","size":"lg","no-wrap":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }